import { EVENT_TYPE_TO_ANIMATION_STOP_REASON } from './constants';

export const listenForTransitionEnd = (element: HTMLElement, callback: EventListener) =>
  Object.keys(EVENT_TYPE_TO_ANIMATION_STOP_REASON).forEach((eventType) =>
    element.addEventListener(eventType, callback),
  );
